import {
  PlantResources,
  RequisitionResources,
  ActivityResources,
  LedgerResources,
  MaterialResources,
} from '@Types/api/common/dictionary';

import { SearchOption, ResourceType } from '../types';

export const transformResponseToOptions = (
  response:
    | Array<RequisitionResources>
    | Array<PlantResources>
    | Array<ActivityResources>
    | Array<LedgerResources>
    | Array<MaterialResources>,
  requestType: ResourceType
): Array<SearchOption> => {
  const transformedMap = [] as SearchOption[];
  response.forEach((item) => {
    if (requestType === 'Activities') {
      const { actId, actName, actNumber } = item as ActivityResources;
      transformedMap.push({
        id: actId,
        code: actNumber,
        desc: actName,
      });
    }
    if (requestType === 'Plants') {
      const { id, code, description: desc } = item as PlantResources;
      transformedMap.push({
        id,
        code,
        desc,
      });
    }
    if (requestType === 'Materials') {
      const { matCode, matDesc, matId } = item as MaterialResources;
      transformedMap.push({
        id: matId,
        code: matCode,
        desc: matDesc,
      });
    }
    if (requestType === 'Resources') {
      const { resCode, resDesc, resID } = item as RequisitionResources;
      transformedMap.push({
        id: resID,
        code: resCode,
        desc: resDesc,
      });
    }
    if (requestType === 'Ledgers') {
      const { code, id, name } = item as LedgerResources;
      transformedMap.push({
        id,
        code,
        desc: name,
      });
    }
  });

  return transformedMap;
};
